<template>
  <div class="rubric-criteria">
    <div
      :class="pointsClass"
      v-show="constructedInteractionText"
      v-html="constructedInteractionText"
    ></div>
    <div
      v-if="localInteractionAttempt.explanation"
      class="playposit-interaction-answer-explanation pb-3 mt-2"
    >
      <div class="body-2 uppercase grey--text text--lighten-1">Grade explanation</div>
      <div
        class="answer-explanation px-2 py-1 grey lighten-2 grey--text text--darken-1" v-html="localInteractionAttempt.explanation"
      />
    </div>
  </div>
</template>

<script>
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'RubricCriteria',
  mixins: [
    Interaction,
  ],
  data: () => ({
    constructedInteractionText: '',
  }),
  computed: {
    pointsClass() {
      return `out-of-${this.localInteraction.pointsAvailable}`;
    },
  },
  methods: {
    constructInteractionText() {
      const div = document.createElement('div');
      div.innerHTML = this.localInteraction.interactionText;
      for (const input of Array.from(div.querySelectorAll('input') || [])) {
        input.setAttribute('type', 'text');
        input.setAttribute('readonly', true);
        input.setAttribute('value', this.localInteractionAttempt.responseText ? this.localInteractionAttempt.responseText : '-');
      }
      return div.innerHTML;
    },
  },
  created() {
    this.$set(this, 'constructedInteractionText', this.constructInteractionText());
  },
};
</script>